import { mapApiCreateApiResponse, mapAPIKeyResponse } from '@/mappers/api-key.mapper';
import { defaultPaginatedResponse, mapPaginatedResponse } from '@/mappers/common.mapper';

import type { ApiKeyCreateFormValues } from '@/schemas/api-key.schema';

import { DEFAULT_PAGE_SIZE } from '@/constants';

import apiClient from '@/lib/api-client';
import { raiseAxiosErrorOrDefault } from '@/lib/error';

import type { ApiKey } from '@/types/api-key.type';
import type { PaginatedResponse, PaginationParams } from '@/types/common.type';

export const fetchAllApiKeys = async (
  params?: PaginationParams
): Promise<PaginatedResponse<ApiKey>> => {
  try {
    return await apiClient.get<PaginatedResponse<ApiKey>>(
      '/keys',
      mapPaginatedResponse(mapAPIKeyResponse),
      {
        params: {
          page: params?.page || 1,
          page_size: params?.page_size || DEFAULT_PAGE_SIZE,
          ...(params?.query && { query: params.query }),
        },
      }
    );
  } catch {
    return defaultPaginatedResponse<ApiKey>();
  }
};

export const createApiKey = async (data: ApiKeyCreateFormValues): Promise<string> => {
  try {
    const response = await apiClient.post<string>('/keys', data, mapApiCreateApiResponse);
    return response;
  } catch (e) {
    raiseAxiosErrorOrDefault(e, 'Failed to create API key');
  }
};

export const deleteApiKeyById = async (apiKeyId: number): Promise<void> => {
  try {
    await apiClient.delete(`/keys/${apiKeyId}`);
  } catch (e) {
    raiseAxiosErrorOrDefault(e, 'Failed to delete API key');
  }
};
